export default { tag: 'client@2.24.0' };